<template>
    <div data-cy="container_campaign_list">
        <div class="grid grid-cols-2 gap-4" atm="campaing-list" data-cy="list_campaign">
            <CampaignItem
                    :data-cy="`card_campaign_item_${index}`"
                    v-for="(campaign, index) in campaigns"
                    :key="campaign.id"
                    :campaign="campaign"
                    :typeTagCamp="typeTagCamp"
            ></CampaignItem>
        </div>
        <div v-if="(isLoaded && !isHaveItem && isSearch)" data-cy="container_search_campaign_empty">
            <Nodata :textData="lbl.not_found" />
        </div>
    </div>
</template>
<script>
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
//component
import CampaignItem from './CampaignItem.vue';
import Nodata from '@/components/Layout/Page/NoData.vue';
//service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';

/**
 * @event onLoaded
 */
export default {
    name: "CampaignList",
    mixins: [LocaleMixin, ModalMixin],
    components: {
        CampaignItem,
        Nodata,
    },
    props: {
        initListConfig:     { type: Object, required: true },
        initFilterConfig:   { type: Object, required: true },
        isSearch:           { type: Boolean, default: false },
    },
    data: function() {
        return {
            listConfig: null,
            filterConfig: null,

            campaigns: [],

            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
            typeTagCamp: null
        };
    },
    created: function() {
        this.listConfig = this.initListConfig;
        this.filterConfig = this.initFilterConfig;

        this.getList();
    },
    methods: {
        reinitList: function(listConfig, listFilter) {
            this.listConfig = listConfig;
            this.filterConfig = listFilter;
            this.campaigns = [];
            this.getList();
        },
        getList: function() {
            return new Promise((resolve) => {
                this.isLoading = true;
                this.modal.loadingModal.show();
                BzbsCampaign.apiGetCampaign(this.listConfig, this.filterConfig).subscribe({
                    next: (campaigns) => {
                        this.listConfig.intSkip += this.listConfig.defaultTopAmount;
                        //check is there are more campaign.
                        if (campaigns && campaigns.length < this.listConfig.defaultTopAmount) {
                            this.listConfig.isSeeMoreEnable = false;
                        }

                        //reinitialize list if no skip.
                        if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                            this.campaigns = [];
                        }

                        for (var campaign of campaigns) {
                            //TODO: Add GA Tracking.
                            this.campaigns.push(campaign);
                        }

                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = this.campaigns.length > 0
                            ? true
                            : false;

                        this.getNewAndPopularConfig();

                        resolve();
                        this.modal.loadingModal.hide();
                        this.$emit('onLoaded');
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        this.listConfig.isSeeMoreEnable = false;

                        if(err.id == 401){
                            this.$router.push('/error');
                        }else{
                            this.errorApi(err);
                        }

                        this.modal.loadingModal.hide();
                        this.$emit('onLoaded');
                        resolve();
                    },
                });
            });
        },

        getNewAndPopularConfig: function () {
            return new Promise((resolve) => {
                BzbsCampaign.tagNewAndPopular()
                    .subscribe({
                        next: (res) => {
                            if (res) {
                                this.typeTagCamp = res;
                            }
                            resolve(true);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            resolve(null);
                        }
                    });
            });
        },

        loadMore: async function() {
            console.log('load more list', this.listConfig.isSeeMoreEnable);
            if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
                return;
            }

            this.modal.loadingModal.show();
            await this.getList();
            this.modal.loadingModal.hide();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
